import { createSlice } from "@reduxjs/toolkit";
import { TIME_FILTER_TYPE } from "Explore/Config/constraint";

const initialState = {
  selectedKeywords: [],
  exploringKeyword: null,
  timeFilter: "all",
  sliderValue: [],
  timeFilterType: TIME_FILTER_TYPE,
  tab: "scholars",
};
const keywordSlice = createSlice({
  name: "concept",
  initialState,
  reducers: {
    setSelectedKeywords: (state, action) => {
      state.selectedKeywords = action.payload;
    },
    setExploringKeyword: (state, action) => {
      state.exploringKeyword = action.payload;
    },
    setTimeFilter: (state, action) => {
      state.timeFilter = action.payload;
    },
    setSliderValue: (state, action) => {
      state.sliderValue = action.payload;
    },
    setTimeFilterType: (state, action) => {
      state.timeFilterType = action.payload;
    },
    setCurrentTab: (state, action) => {
      state.tab = action.payload;
    },
  },
});
export const {
  setSelectedKeywords,
  setExploringKeyword,
  setTimeFilter,
  setSliderValue,
  setTimeFilterType,
  setCurrentTab,
} = keywordSlice.actions;
export default keywordSlice.reducer;
